import React from "react";

export const rawStepsMainView = [
  {
    inAppID: "#hc-nav-tab-inbox",
    inAppContent: (
      <div>
        <b>Welcome to Hubchart!</b>
        <br />
        Your <b>Inbox</b> is where all conversation and updates happen.
      </div>
    ),
  },{
    inAppID: "#message-nav-filter",
    inAppContent: (
      <div>
        Use <b>filters</b> is where all conversation and updates happen.
      </div>
    ),
  },{
    inAppID: "#hc-nav-tab-group",
    inAppContent: (
      <div>
        Create a <b>Regular Group</b> for general collaboration.
      </div>
    ),
  },{
    inAppID: "#hc-nav-tab-patient",
    inAppContent: (
      <div>
        Create a <b>Patient Hub</b> to collaborate on individual patients.
      </div>
    ),
  },
];

export const rawStepsDrawerView = [
  {
    inAppID: "#hc-profile-setting-status",
    inAppContent: (
      <div>
        Set your availability status so others know when you're working.
      </div>
    ),
  },{
    inAppID: "#hc-profile-setting-profile",
    inAppContent: (
      <div>
        View and update your profile here.
      </div>
    ),
  },{
    inAppID: "#hc-profile-setting-qr-code",
    inAppContent: (
      <div>
        Generate or scan a QR code to manage clinic queue check-ins.
      </div>
    ),
  },
];

export const rawStepsQrCodeView = [
    {
      inAppID: "#hc-nav-qr-generate",
      inAppContent: (
        <div>
          Use QR check-in to create a digital waiting line for walk-in patients.
        </div>
      ),
      placement: "right",
    },{
      inAppID: "#hc-nav-qr-code",
      inAppContent: (
        <div>
          Patient scan this QR code and enter their details to join your queue.
        </div>
      ),
    },{
      inAppID: "#hc-nav-qr-patient-list",
      inAppContent: (
        <div>
          Once patients enter their details, they are automatically added to your queue list.
        </div>
      ),
    },{
      inAppID: "#hc-nav-qr-patient-next",
      inAppContent: (
        <div>
          Tap `<b>Next Patient</b>` to call the next person in line.
        </div>
      ),
    },{
      inAppID: "#hc-nav-qr-list-open",
      inAppContent: (
        <div>
          Open displays your organization's active queue.
        </div>
      ),
    },{
      inAppID: "#hc-nav-qr-list-close",
      inAppContent: (
        <div>
          Closed displays your past queues for reference.
        </div>
      ),
    },
];

export const rawStepsOrgView = [
  {
    inAppID: "#hc-profile-setting-org-owner",
    inAppContent: (
      <>
        This is your organization workspace
        <br /><br />
        Every new account starts with a default organization under your name.
      </>
    ),
  },{
    inAppID: "#hc-profile-setting-org-update",
    inAppContent: "Click Edit button to rename your organization to match your clinic or team.",
  },{
    inAppID: "#hc-profile-setting-org-add",
    inAppContent: "Click + to add a member to your organization.",
  },{
    inAppID: "#hc-profile-setting-org-add-modal",
    inAppContent: (
      <>
        Add members by entering their mobile number.
        <br />
        They'll receive an SMS invitation to join your organization.
      </>
    ),
  },{
    inAppID: ".toast-base-main",
    inAppContent: (
      <>
        <bold>When adding existing Hubchart users:</bold>
        <br /><br />
        Existing Hubchart users must leave their current organization before joining yours.
      </>
    ),
  },{
    inAppID: ".toast-base-main",
    inAppContent: (
      <>
        <bold>When adding new users or existing users without organization:</bold>
        <br /><br />
        New users recieve a signup link and automatically join after registering while existing usres without organization gets automatically added to yours.
      </>
    ),
  },{
    inAppID: "#hc-profile-setting-org-leave",
    inAppContent: (
      <>
        If you leaveas owner, ownership transfers to the next member.
        <br /><br />
        If you're the only member, the organization become ownerless.
      </>
    ),
  },
];

// IN APP DEMO DATA - FOR QR CODE MODAL
export const demoQRQueueModalData = {
    code: "Welcome to Hubchart!",
    current: {
        current_serving: "1",
        total_waiting: 1,
    },
    queueList: [
        {
            ticket_number: "2",
            name: "Maricar Santos",
            mobile_number: "639179876543",
            status: "waiting",
        },{
            ticket_number: "1",
            name: "Michael Reyes",
            mobile_number: "639101234451",
            status: "called",
        }
    ],
    queueCodeList: [
        {
            generator: { displayName: "Jhon Brown" },
            code: "8kL2p9XmN4vR7wT1zQM7vX4rP1tZ9qL2wN5k",
            createdAt: (new Date()).setDate((new Date()).getDate() - 3), 
        }, {
            generator: { displayName: "Aldin Richardson" },
            code: "jH5yG2bF9aS8dK3nC6zQM7vN4vRH3422158",
            createdAt: new Date(), 
        }
    ],
};